<script setup lang="ts">
	import { useBaseFile } from './BaseFile';
	import {ref, reactive, computed, onMounted, onUnmounted} from 'vue';
	import FileBrowserModal from './FileBrowserModal.vue';
	import CloseCross from "@/fd/editors/file/CloseCross.vue";
	import {injectEnv} from "@fd/Environment";
	
	const props = defineProps({
		showDisc: { type: Boolean, required: false, default: true },
		showClip: { type: Boolean, required: false, default: true },
		showDoc: { type: Boolean, required: false, default: true },
		showTitles: { type: Boolean, required: false, default: true },
		clickClass: String,
		property: String,
		value: String,
		preview: Boolean,
		thumbnailWidth: String,
		thumbnailHeight: String,
		restApi: String,
		typeFilter: String,
		readOnly: Boolean,
		zoneClass: String,
		zoneStyle: String,
		type:  { type: String, required: false, default: "entry" }
	});
	
	const env = injectEnv();
	
	const emit = defineEmits(['uploaded']);
	
	const { CLASSEVENTS, dropClass, errorMessage, isError, 
			uploadingFile, uploading, uploadingFileDone,
			active, setActive, setInactive, 
			onDrop, onInputChange, onClipboard, onCrmFile,
			loadFile } = useBaseFile(props, uploadedFile,uploadedAllFiles, emit);
	
	//const { thumbnailUrl, limitFileName } = useCrmFormFile();
	
	const fileEntryValue = ref(props.value);
	
	const fileInputId = ref(null);
	
	function uploadingFileName(): string {
		return uploadingFile.value !== null?uploadingFile.value.getName():"-";
	}
	defineExpose({uploadingFileName});


	const thumbnailUrl = computed(() => {
		let url:string = "thumbnail?crmFormFile="+fileEntryValue.value+"&random="+Math.random();
		if (props.thumbnailHeight && props.thumbnailWidth) {
			url +="&height="+props.thumbnailHeight+"&width="+props.thumbnailWidth;
		}
		return url;
	});

	const isPicture = computed(() => {
		if (uploadingFile.value !== null) {
			//console.log("isPicture:"+uploadingFile.getType());
			return  uploadingFile.value.getType().includes("image") || 
					(uploadingFile.value.attFileContentType && uploadingFile.value.attFileContentType.includes("image"));
		}
		return false;
	});
	
	function preventDefaults(e): void {
		e.preventDefault();
	}
	
	function uploadedFile(data): void {
		console.log("uploaded file:"+JSON.stringify(data));
		fileEntryValue.value = data.id;
		uploadingFile.value.setAttFileContentType(data.contentType);
		
		emit('uploaded',uploadingFile.value);
	}
	
	function uploadedAllFiles(): void {
		//nothing
	}
	
	
	function removeFile(): void {
		console.log("removing:"+fileEntryValue.value);
		fileEntryValue.value="";
		uploadingFile.value=null;
	}
	
	function onFileInput(): void {
		fileInputId.value.click();
	}
	
	onMounted(() => {
		CLASSEVENTS.forEach((eventName) => {
			document.body.addEventListener(eventName, preventDefaults);
		});
		
		if (fileEntryValue.value && fileEntryValue.value.length>0) {
			loadFile(fileEntryValue.value).then((file)=>{
				uploadingFile.value=file;
				uploadingFileDone.value=true;
			});
		}
	});
	
	onUnmounted(() => {
		CLASSEVENTS.forEach((eventName) => {
			document.body.removeEventListener(eventName, preventDefaults);
		});
	});
</script>
<template>
	<slot></slot>
	<div v-if="readOnly" class="fileZone" :style="zoneStyle">
		<div class="fileZoneReadOnlyText">
			<span class="fi" :class="clickClass"></span>
			<div>{{env.msg("fileZone.drag.short")}}</div>
		</div>
	</div>
	<div v-else @drop.prevent="onDrop" :data-active="active" 
		@dragenter.prevent="setActive" @dragover.prevent="setActive"
		@dragleave.prevent="setInactive" :class="dropClass" class="fileZone" :style="zoneStyle">
		<template v-if="uploadingFile">
			<close-cross v-show="uploadingFileDone" class="fileZoneCancelIcon" @click="removeFile"></close-cross>
			<img v-if="preview && uploadingFileDone && isPicture" :src="thumbnailUrl" class='fileZoneImg'/>
			<div v-else class="fileZoneText">
				<span v-show="uploading" class="fi uploadingIcon"></span>
				<span v-if="showTitles">{{uploadingFile.uploadingTitle}}</span>
			</div>
		</template>
		<template v-else>
			<div v-if="active" class="fileZoneText">
				<span v-if="showTitles">{{env.msg("fileZone.drop")}}</span>
			</div>
			<template v-else-if="!showTitles" >
				<div class="fileZoneText">
					<span class="fi" @click.prevent="onFileInput"></span>
				</div>
			</template>
			<template v-else >
				<div class="fileZoneText">
					<span>{{env.msg("fileZone.drag.short")}}</span>
				</div>
				<div class="fileZoneButtons">
					<button v-if="showDisc" class="sbutton" @click.prevent="onFileInput">
						<span class="fi"></span> <span>{{env.msg("fileZone.fromDisc")}}</span>
					</button>
					<button v-if="showClip" class="sbutton" @click.prevent="onClipboard">
						<span class="fi"></span> <span>{{env.msg("fileZone.fromClipboard")}}</span>
					</button>
					<file-browser-modal v-if="showDoc" :button="true" @select-file="onCrmFile"/>
				</div>
			</template>
		</template>
		<input type="file" ref="fileInputId" @change="onInputChange" style="display: none;" />
		<input type="hidden" :name="property" :value="fileEntryValue" />
	</div>
	<div v-if="isError" class="errors">
		<span class="perr">{{errorMessage}}</span>
	</div>
</template>
